import React, { useState, forwardRef, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const LeftSidebar = forwardRef((props, ref) => {
  const location = useLocation();
  const [expandedMenus, setExpandedMenus] = useState({
    dashboard: false,
    ems: false
  });
  const [currentModule, setCurrentModule] = useState(''); // 'EMS' or 'ROS'
  const [theme, setTheme] = useState("light"); // light or dark


  // Get current module from session storage
  useEffect(() => {
    const module = sessionStorage.getItem('Module') || 'ROS'; // Default to ROS if not set
    setCurrentModule(module);
  }, []);
  useEffect(() => {
    // If your app toggles dark mode via a class on <body> or <html>, detect that:
    const observer = new MutationObserver(() => {
      if (document.body.classList.contains("dark")) {
        setTheme("dark");
      } else {
        setTheme("light");
      }
    });

    observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });

    // Initial load
    if (document.body.classList.contains("dark")) {
      setTheme("dark");
    }

    return () => observer.disconnect();
  }, []);

  // Automatically expand parent menus when child routes are active
  useEffect(() => {
    const path = location.pathname;

    setExpandedMenus({
      dashboard: path.startsWith('/ros/dashboard') ||
        path.startsWith('/ros/alarms') ||
        path.startsWith('/ros/casesubmission') ||
        path.startsWith('/ros/submittedcase') ||
        path.startsWith('/ros/completedcase') ||
        path.startsWith('/ros/resourcemanagement') ||
        path.startsWith('/ros/usermanagement') ||
        path.startsWith('/ros/system'),
      ems: path.startsWith('/ems')
    });
  }, [location.pathname]);

  const toggleMenu = (menu) => (e) => {
    e.preventDefault();
    setExpandedMenus(prev => ({
      ...prev,
      [menu]: !prev[menu]
    }));
  };

  // Custom NavLink component to handle exact matching for parent routes
  const CustomNavLink = ({ to, children, ...props }) => {
    const isActive = location.pathname === to;
    return (
      <NavLink
        to={to}
        className={isActive ? 'active' : ''}
        {...props}
      >
        {children}
      </NavLink>
    );
  };

  const userRole = sessionStorage.getItem("Role_Name");

  return (
    <aside className="left-sidebar with-vertical" ref={ref}>
      <div className="brand-logo d-flex align-items-center justify-content-between">
  {userRole === "Admin" || userRole === "EMS Requester" ? (
    // Clickable logo for Admin and EMS Requester
    <a href="/ems/dashboard" className="text-nowrap logo-img">
      {theme === "dark" ? (
        <img
          src="../assets/images/logos/ems-logo-light.png"
          alt="Logo-Light"
          height="38"
          className="logo"
        />
      ) : (
        <img
          src="../assets/images/logos/EMS-pro-logo.png"
          height="38"
          alt="Logo-Dark"
          className="logo"
        />
      )}
    </a>
  ) : (
    // Non-clickable logo for all other roles
    <div className="text-nowrap logo-img">
      {theme === "dark" ? (
        <img
          src="../assets/images/logos/ems-logo-light.png"
          alt="Logo-Light"
          height="38"
          className="logo"
        />
      ) : (
        <img
          src="../assets/images/logos/EMS-pro-logo.png"
          height="38"
          alt="Logo-Dark"
          className="logo"
        />
      )}
    </div>
  )}

  <button className="sidebartoggler ms-auto text-decoration-none fs-5 d-block d-xl-none">
    <i className="ti ti-x"></i>
  </button>
</div>

      <nav className="sidebar-nav scroll-sidebar pt-5" data-simplebar>
        <ul id="sidebarnav">
          {/* ROS Section - only show if module is ROS */}
          {currentModule === 'ROS' && (
            <>
              <li className="sidebar-item">
                <a href="#"
                  className={`sidebar-link has-arrow w-100 text-start ${expandedMenus.dashboard ? 'active' : ''}`}
                  aria-expanded={expandedMenus.dashboard}
                  onClick={toggleMenu('dashboard')}
                >
                  <span className="d-flex">
                    <i className="ti ti-layout-grid"></i>
                  </span>
                  <span className="hide-menu">ROS</span>
                </a>

                <ul className={`collapse first-level ${expandedMenus.dashboard ? 'show' : ''}`}>
                  <li className="sidebar-item">
                    <CustomNavLink to="/ros/dashboard" className="sidebar-link">
                      <div className="round-16 d-flex align-items-center justify-content-center">
                        <i className="ti ti-circle"></i>
                      </div>
                      <span className="hide-menu">ROS Dashboard</span>
                    </CustomNavLink>
                  </li>
                  <li className="sidebar-item">
                    <CustomNavLink to="/ros/alarms" className="sidebar-link">
                      <div className="round-16 d-flex align-items-center justify-content-center">
                        <i className="ti ti-circle"></i>
                      </div>
                      <span className="hide-menu">Alarms</span>
                    </CustomNavLink>
                  </li>
                  <li className="sidebar-item">
                    <CustomNavLink to="/ros/casesubmission" className="sidebar-link">
                      <div className="round-16 d-flex align-items-center justify-content-center">
                        <i className="ti ti-circle"></i>
                      </div>
                      <span className="hide-menu">New Case Submission</span>
                    </CustomNavLink>
                  </li>
                  <li className="sidebar-item">
                    <CustomNavLink to="/ros/submittedcase" className="sidebar-link">
                      <div className="round-16 d-flex align-items-center justify-content-center">
                        <i className="ti ti-circle"></i>
                      </div>
                      <span className="hide-menu">Submitted Case</span>
                    </CustomNavLink>
                  </li>
                  <li className="sidebar-item">
                    <CustomNavLink to="/ros/completedcase" className="sidebar-link">
                      <div className="round-16 d-flex align-items-center justify-content-center">
                        <i className="ti ti-circle"></i>
                      </div>
                      <span className="hide-menu">Completed Case</span>
                    </CustomNavLink>
                  </li>
                  <li className="sidebar-item">
                    <CustomNavLink to="/ros/reports-analyst" className="sidebar-link">
                      <div className="round-16 d-flex align-items-center justify-content-center">
                        <i className="ti ti-circle"></i>
                      </div>
                      <span className="hide-menu">Reports & Analytics</span>
                    </CustomNavLink>
                  </li>
                  <li className="sidebar-item">
                    <CustomNavLink to="/ros/usermanagement" className="sidebar-link">
                      <div className="round-16 d-flex align-items-center justify-content-center">
                        <i className="ti ti-circle"></i>
                      </div>
                      <span className="hide-menu">User Management</span>
                    </CustomNavLink>
                  </li>
                  <li className="sidebar-item">
                    <CustomNavLink to="/ros/resourcemanagement" className="sidebar-link">
                      <div className="round-16 d-flex align-items-center justify-content-center">
                        <i className="ti ti-circle"></i>
                      </div>
                      <span className="hide-menu">Resource Management</span>
                    </CustomNavLink>
                  </li>
                  <li className="sidebar-item">
                    <CustomNavLink to="/ros/system-configuration" className="sidebar-link">
                      <div className="round-16 d-flex align-items-center justify-content-center">
                        <i className="ti ti-circle"></i>
                      </div>
                      <span className="hide-menu">System Configuration</span>
                    </CustomNavLink>
                  </li>
                </ul>
              </li>
              <hr />
            </>
          )}

          {/* EMS Section - only show if module is EMS */}
          {currentModule === 'EMS' && (
            <>
              <li className="sidebar-item">
                <a
                  className={`sidebar-link has-arrow w-100 text-start ${expandedMenus.ems ? 'active' : ''}`}
                  aria-expanded={expandedMenus.ems}
                  onClick={toggleMenu('ems')}
                >
                  <span className="d-flex">
                    <i className="ti ti-tournament"></i>
                  </span>
                  <span className="hide-menu">EMS</span>
                </a>

                <ul className={`collapse first-level ${expandedMenus.ems ? 'show' : ''}`}>
                  {/* Admin: Can see all tabs */}
                  {userRole === "Admin" && (
                    <>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/dashboard" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">Dashboard</span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/alarms" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">Alarms</span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/user-management" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">User Management</span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/resources" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">Resource Management</span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/cases" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">EMS Cases</span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/closed-cases" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">EMS Closed Cases</span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/transfer-cases" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">Transfer Cases</span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/requests" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">EMS Requests</span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/hospital-new-cases" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">Hospital New Cases</span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/transfer-cases-final-approval" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">
                            Transfer cases <br /> for final approval
                          </span>
                        </CustomNavLink>
                      </li>

                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/rejected-case" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">Rejected Cases</span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/reports-analyst" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">Reports & Analytics</span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/system-configuration" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">System Configuration</span>
                        </CustomNavLink>
                      </li>
                    </>
                  )}

                  {/* EMS Resource Manager */}
                  {userRole === "EMS Resource Manager" && (
                    <>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/user-management" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">User Management</span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/resources" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">Resource Management</span>
                        </CustomNavLink>
                      </li>

                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/hospital-new-cases" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">Hospital New Cases</span>
                        </CustomNavLink>
                      </li>

                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/rejected-case" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">Rejected Cases</span>
                        </CustomNavLink>
                      </li>

                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/closed-cases" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">EMS Closed Cases</span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/transfer-cases" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">Transfer Cases</span>
                        </CustomNavLink>
                      </li>
                    </>
                  )}

                  {/* EMS Requester */}
                  {userRole === "EMS Requester" && (
                    <>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/dashboard" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">Dashboard</span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/resources" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">Resource Management</span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/cases" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">EMS Cases</span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/transfer-cases" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">Transfer Cases</span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/transfer-cases-final-approval" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">
                            Transfer cases <br /> for final approval
                          </span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/closed-cases" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">EMS Closed Cases</span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/rejected-case" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">Rejected Cases</span>
                        </CustomNavLink>
                      </li>
                    </>
                  )}

                  {/* EMS Team */}
                  {userRole === "EMS Team" && (
                    <>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/alarms" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">Alarms</span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/resources" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">Resource Management</span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/requests" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">EMS Requests</span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/closed-cases" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">EMS Closed Cases</span>
                        </CustomNavLink>
                      </li>
                    </>
                  )}

                  {/* Hospital Representative (Nurse) */}
                  {userRole === "Hospital Representative (Nurse)" && (
                    <>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/hospital-new-cases" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">Hospital New Cases</span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/transfer-cases" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">Transfer Cases</span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/closed-cases" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">EMS Closed Cases</span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/rejected-case" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">Rejected Cases</span>
                        </CustomNavLink>
                      </li>
                    </>
                  )}

                  {/* Hospital Representative (Doctor) */}
                  {userRole === "Hospital Representative (Doctor)" && (
                    <>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/transfer-cases" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">Transfer Cases</span>
                        </CustomNavLink>
                      </li>
                      <li className="sidebar-item">
                        <CustomNavLink to="/ems/rejected-case" className="sidebar-link">
                          <div className="round-16 d-flex align-items-center justify-content-center">
                            <i className="ti ti-circle"></i>
                          </div>
                          <span className="hide-menu">Rejected Cases</span>
                        </CustomNavLink>
                      </li>

                    </>
                  )}
                </ul>
              </li>
              <hr />
            </>
          )}

          {/* Common items that should always be visible */}
          <li className="sidebar-item">
            <CustomNavLink to="/ems/profile" className="sidebar-link">
              <span className="rounded-3"><i className="ti ti-user-circle"></i></span>
              <span className="hide-menu">Profile</span>
            </CustomNavLink>
          </li>

          {/* <li className="sidebar-item">
            <CustomNavLink to="/help" className="sidebar-link">
              <span className="rounded-3"><i className="ti ti-message-report"></i></span>
              <span className="hide-menu">Help & Support</span>
            </CustomNavLink>
          </li> */}

          <li className="sidebar-item">
            <CustomNavLink to="/ems/contact" className="sidebar-link">
              <span className="rounded-3"><i className="ti ti-alert-circle"></i></span>
              <span className="hide-menu">Contact Us</span>
            </CustomNavLink>
          </li>

          {/* <li className="sidebar-item">
            <CustomNavLink to="/news" className="sidebar-link">
              <span className="rounded-3">
                <i className="ti ti-file-description"></i>
              </span>
              <span className="hide-menu">News & Updates</span>
            </CustomNavLink>
          </li> */}
        </ul>
      </nav>
    </aside>
  );
});

export default LeftSidebar;